import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { environment as ENV } from '../../../environments/environment';
import { URL_MAP } from '../../shared/urlMap';

export interface ProgramaVentaGanadaResponse {
  idBenPrograma: number;
  programa: string;
  nombrePrograma: string;
}

export interface LineaNegocioVentaGanadaResponse {
  lineaNegocio: string;
  programas: ProgramaVentaGanadaResponse[];
}

export interface BeneficiarioVentaGanadaResponse {
  idBeneficiario: number;
  nombreCompleto: string;
  lineasNegocio: LineaNegocioVentaGanadaResponse[];
}

export interface ProgramaColectivoData {
  idBenPrograma: number;
  lineaNegocio: string;
  programa: string;
  nombrePrograma: string;
}

export interface VentaGanadaGetResponse {
  status: boolean;
  codeStatus: string;
  message: string;
  data: {
    idCotizacion: number;
    idTipoCotizacion: number;
    beneficiarios: BeneficiarioVentaGanadaResponse[] | null;
    colectivo: {
      subsidio: string;
      programas: ProgramaColectivoData[];
    } | null;
  };
  errorMessage: string | null;
}

export interface SeleccionVentaGanada {
  idBeneficiario: number;
  lineaNegocio: string;
  idBenPrograma: number;
}

export interface VentaGanadaPostRequest {
  usuarioCierre: string;
  selecciones: SeleccionVentaGanada[];
}

export interface RadicacionData {
  idCierreRadicacion: number;
  lineaNegocio: string;
  programa: string;
  nombrePrograma: string;
}

export interface VentaGanadaPostData {
  idCierre: number;
  idCotizacion: number;
  fechaCierre: string;
  usuarioCierre: string;
  esExitosa: string;
  idMotivoCierre: number | null;
  observaciones: string | null;
  idTipoCotizacion: number;
  nombreTipoCotizacion: string;
  estadoCotizacion: number;
  radicaciones: RadicacionData[] | null;
}

export interface VentaGanadaPostResponse {
  status: boolean;
  codeStatus: string;
  message: string;
  data: VentaGanadaPostData | null;
  errorMessage: string | null;
}

@Injectable({
  providedIn: 'root'
})
export class VentaGanadaService {
  private readonly baseUrl = `${ENV.HOST}${URL_MAP.API.COTIZADOR_VENTA_GANADA}`;

  constructor(private httpClient: HttpClient) {}

  getVentaGanada(idCotizacion: number): Observable<VentaGanadaGetResponse> {
    return this.httpClient
      .get<VentaGanadaGetResponse>(`${this.baseUrl}/${idCotizacion}/venta-ganada`)
      .pipe(
        catchError(error => {
          console.error('Error en getVentaGanada:', error);
          return throwError(() => error);
        })
      );
  }

  postVentaGanada(
    idCotizacion: number,
    body: VentaGanadaPostRequest
  ): Observable<VentaGanadaPostResponse> {
    return this.httpClient
      .post<VentaGanadaPostResponse>(`${this.baseUrl}/${idCotizacion}/venta-ganada`, body)
      .pipe(
        catchError(error => {
          console.error('Error en postVentaGanada:', error);
          return throwError(() => error);
        })
      );
  }
}
